import {Component, Input} from '@angular/core';

@Component({
  selector: 'fe-dots-menu',
  templateUrl: './fe-dots-menu.component.html',
  styleUrls: ['./fe-dots-menu.component.scss']
})
export class FeDotsMenuComponent {
  @Input() xPosition: string = 'before';

}
